import React, { useContext, useState } from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
} from '@mui/material';
import ProjectContext from '../../contexts/ProjectContext';
import ModalListItem from '../listitem/ModalListItem';

export default function ProjectSelectDialog({ open, onClose, projects, setSelectedProject }) {
	
	const projectContext = useContext(ProjectContext);

	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth="md" // Set the maximum width
            fullWidth // Ensure the dialog takes up the full width up to the max width
			PaperProps={{
				sx: {
					backgroundColor: '#222', // Dark grey background
					color: '#fff', // White text color
				},
			}}>
			<DialogTitle sx={{ backgroundColor: '#222', color: '#fff' }}>
				Select a Project
			</DialogTitle>
			<DialogContent>
				{projects
					.map(project => ({
						...project,
						primaryText: project?.project_name,
						secondaryText: project?.project_db,
						icon: project?.project_image,
						isActive: project?.project_db === projectContext?.project_db,
						onClick: () => setSelectedProject(project)
					}))
					.map((project, index) => 
						<ModalListItem
							key={index}
							item={project}
						/>
                	)
				}
			</DialogContent>
		</Dialog>
	);
}